<!--单位信息模块-->
<template>
  <div class="workStateBody usePowerUnitDiv">
    <div class="topLeftTitleContent">运行情况</div>
    <div class="workStateContent bodyBorder">
      <vchart class="vcharted" ref='vchart' style="height: 250px !important;"></vchart>
    </div>
  </div>
</template>
<script>
  import vchart from '@/components/module/chart/vchart.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      vchart
    },
    data () {
      return {
        zhuzhuang: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // Use axis to trigger tooltip
              type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          grid: {
            top: '5%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#ffffff',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
          },
          color: ['#42a1ff'],
          yAxis: {
            type: 'category',
            data: ['用电排行','电压','机加车间','桥壳二车间','桥壳一车间'],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
          },
          series: [
            {
              type: 'bar',
              label: {
                show: true
              },
              showBackground: true,
              emphasis: {
                focus: 'series'
              },
              barWidth: 15,
              data: [320.25,23,100,223,0]
            }
          ]
        },
        saveUnitInfo: {
          checkCompleted: 0,
          checkPlan: 0,
        },
        noAlarm: 0,
        alarm: 0,
        unConfirmedAlarm: 0, //未确认告警
        earlyWarning: 0,
        monthEvent: 0,
        lastYearMonthEvent: 0, //上年本月
        lastMonthEvent: 0, //上月事件
        eventObj: {
          "monthWclCount": 0, //未确认告警
          "monthAllCount": 0, //本月总告警
          "allGjCount": 0, //总告警数
          "lastMonthAllCount2": "0%",
          "allCount": 0, //本月总数
          "lastMonthAllCount": 0, //上月同期总告警
          "lastYearMonthAllCount2": "0%", //上年同期
          "lastYearMonthAllCount": 0, //上年同期总告警
          "allYjCount": 0,//总预警
        }
      }
    },
    created () {},
    mounted () {
      this.yonghu()
    },
    destroyed () {
      removeTask('refreshWorkStateNoWork')
    },
    computed: {
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getOnYear () {
        //同比
        if(this.lastYearMonthEvent!=0) {
          return ((this.monthEvent-this.lastYearMonthEvent)*100/this.lastYearMonthEvent).toFixed(2)
        }
        return 0
      },
      ringRatio () {
        if(this.lastMonthEvent!=0) {
          return parseFloat(((this.monthEvent-this.lastMonthEvent)*100/this.lastMonthEvent).toFixed(2))
        }
        return 0
      },
      safetyDate () {
        return Math.floor((Date.now()-this.nowUnit.joinTime)/(24*3600*1000))
      },
      haveDate () {
        return Math.floor((this.nowUnit.expirationTime-Date.now())/(24*3600*1000))
      }

    },
    watch: {
      saveUnitInfo (nv,ov) {},
      nowUnit (nv,ov) {
        this.initData()
        this.eventListData()
      }
    },
    methods: {
      // 人民电器储能看板->获取看板总充放功率列表
      yonghu () {
        this.$refs.vchart.setData(this.zhuzhuang,true);


        //获取看板总充放功率列表
        request({url: "/deNa/findAreaEnergyToDay",method: "get"}).then(res => {
          // console.log(res,'获取看板总充放功率列表');
          if(res.code==200&&res.data) {
            //             {
            //   "code": 200,
            //   "message": "操作成功",
            //   "data": {
            //     "桥装车间": 320.25,
            //     "机加车间": 0,
            //     "桥壳一车间": 0,
            //     "部装车间": 0,
            //     "桥壳二车间": 0
            //   }
            // }  
            var name=[];
            var d=[]
            for(const key in res.data) {
              name.push(key);
              d.push(res.data[key])
            }

            this.zhuzhuang.yAxis.data=name.reverse();
            this.zhuzhuang.series[0].data=d.reverse();
            this.$refs.vchart.setData(this.zhuzhuang,true);
          }
        })
        this.$refs.vchart.setData(this.zhuzhuang,true);
      },
      initData () {
        if(isempty(this.nowUnit)) {
          setTimeout(() => {
            this.initData()
          },100)
          return
        }
        this.$api.unitApi.getUnitInfo(this.nowUnit.id,respon => {
          if(respon!=null) {
            this.saveUnitInfo=respon
          } else {
            this.saveUnitInfo={
              checkCompleted: 0,
              checkPlan: 0,
            }
          }
        })
      },
      isemptyUndefined (data) {
        if(data==undefined) {
          return 0
        }
        return data
      },
      eventListData () {
        this.$api.eventApi.countUnitEvents(this.nowUnit.id,respon => {
          if(respon=="正在获取中。。。请稍后") {
            setTimeout(() => {
              this.$api.eventApi.countUnitEvents(this.nowUnit.id,respon => {
                this.eventObj=respon
                this.eventObj.lastMonthAllCount2=respon["lastMonthAllCount%"]
                this.eventObj.lastYearMonthAllCount2=respon["lastYearMonthAllCount%"]
              })
            },7000);
          } else {
            this.eventObj=respon
            this.eventObj.lastMonthAllCount2=respon["lastMonthAllCount%"]
            this.eventObj.lastYearMonthAllCount2=respon["lastYearMonthAllCount%"]
          }
        })
      }
    }
  }
</script>

<style scoped>
  .vcharted {
    width: 100%;
    height: 250px !important;
  }

  @import url("../../../components/css/usePowerUnit.css");

  .workStateBody {
    height: 274px;
  }

  .workStateBody .workStateContent {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: calc(100% - 31px);
  }

  .workStateBody .workStateLeft {
    width: 20%;
    height: 90%;
  }

  .workStateBody .workStateLeft .workStateLeftTop {
    width: 100%;
    height: 38%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .workStateBody .workStateLeft .workStateLeftTop p {
    color: #999999;
    letter-spacing: .01rem;
    line-height: .3rem;
  }

  .workStateBody .workStateLeft .workStateLeftBottom {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 62%;
    justify-content: center;
  }

  .workStateBody .workStateRigthBottom {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .workStateBody .workStateRigth {
    width: 70%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .workStateBody .workStateRigth .workStatebuttonLine {
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChild {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }

  .workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChildValue span {
    color: #FF3300;
    font-size: 20px;
    font-weight: 600;
  }

  .workStateBody .workStateRigth .workStateRigthBottom {
    width: calc(100% - 10px);
    height: 50%;
    display: flex;
    align-items: center;
    padding: 0 4px;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomNone {
    height: 81%;
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: none;
    border: 1px solid #ccc;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 78%;
    justify-content: space-around;
    height: 90%;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo .workStateRigthBottomTwoChild {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 40%;
    background: none;
    border: 1px solid #ccc;
    width: 100%;
  }
</style>